// 图片加载工具函数

// 读取 assets/images 目录下的所有图片
const imagesContext = require.context('@/assets/images', true, /\.(png|jpg|jpeg|gif|svg)$/);

// 图片对象
const images = {};

// 遍历所有图片，创建引用
imagesContext.keys().forEach(key => {
  // 提取图片名称（去掉路径和扩展名）
  const imageName = key
    .replace('./', '') // 去掉 ./ 前缀
    .replace(/\//g, '_') // 将路径分隔符替换为下划线
    .replace(/\.(png|jpg|jpeg|gif|svg)$/, ''); // 去掉扩展名
  
  // 存储图片引用
  images[imageName] = imagesContext(key)
});

// 导出图片对象
export default images;